<template>
  <div class="">
    <div class="row mt-3">
      <div class="col">
        <div class="list-group">
          <draggable v-model="authors" :element="'div'" :options="{handle:'.handle'}">
            <div class="border-left border-right border-top pl-3 pr-3" v-for="(author) in authors"
                 v-bind:key="author.id">
              <div class="row border-bottom pt-1"
                   v-bind:class="{'alert alert-danger p-0 mb-0': (authorvalidation.is_checked === true && authorvalidation.status === false) && hasError(author.id)}">
                <div class="col col-sm-1 d-flex">
                      <span class="d-flex mr-auto"
                            v-if="(authorvalidation.is_checked === true && authorvalidation.status === false) && hasError(author.id)">
                    <router-link :to="'authors/author/' + author.id + '/edit'"><icon
                      :icon="['fad', 'exclamation-triangle']"
                      class="fa-1x text-danger mx-auto"/></router-link>
                  </span>
                  <span v-else class=" float-left font-weight-bold">{{author.order}}</span>
                  <icon :icon="['fad', 'bars']" v-if="settings.authors.reorder"
                        class="text-info mx-auto handle"/>&nbsp;
                </div>
                <!--                PRESENTER-->
                <div class="col-4 col-sm-1 d-flex trimText" v-if="settings.authors.presenter_change">
                  <div class="">
                    <div class="pointer-click"
                         v-if="author.role_id == 2">
                      <icon :icon="['fal', 'check-square']" class="text-success"/>&nbsp;{{_[abstract.setting_submission_id].buttons.presenter}}
                    </div>
                    <div class="pointer-click" v-else
                         v-on:click="changeToPresenter(author)">
                      <icon :icon="['fal', 'square']"/>&nbsp;{{_[abstract.setting_submission_id].buttons.presenter}}
                    </div>
                  </div>
                </div>
                <div class="col col-sm-1 " v-else>
                  <div class="">
                    <span v-if="author.role_id == 2">{{_[abstract.setting_submission_id].author.presenter}}</span>
                    <span v-else>{{_[abstract.setting_submission_id].author.author}}</span>
                  </div>
                </div>
                <div class="w-100 d-block d-sm-none"></div>
                <!--                  AUTHOR-->
                <div class="col col-sm-3 trimText">
                  <router-link :to="'authors/author/' + author.id + '/edit'" class="">
                    <span class="font-weight-bold">
                      <icon :icon="['fad', 'user']"/> | {{author.firstname}} {{author.lastname}}
                    </span>
                  </router-link>
                </div>
                <div class="col-3 col-sm-1">
                  <!--                AUTHOR EDIT-->
                  <router-link class=""
                               :to="'authors/author/' + author.id + '/edit'">
                    <icon :icon="['fad', 'pencil-alt']" class=""/>
                  </router-link>
                  <span v-on:click="deleteAuthorShowModal(author)" v-if="authors.length > 1">
                          &nbsp;<icon :icon="['fad', 'trash-alt']" class="text-danger"/>
                        </span>
                  <span v-else>
                    &nbsp;<icon :icon="['fad', 'trash-alt']" class="disabled"/>
                  </span>
                </div>
                <!--                INSTITUTE-->
                <div class="w-100 d-block d-sm-none"></div>
                <div class="col col-sm-6">
                  <InstituteList :author_id="author.id"
                                 v-if="author.institute && author.institute.length > 0"></InstituteList>
                  <div v-else>
                    <div class="row">
                      <div class="col">
                        <router-link :to="'authors/author/' + author.id + '/institute/add'">
                          <span class="text-danger"><icon
                            :icon="['fad', 'exclamation']"/> {{_[abstract.setting_submission_id].author_overview.non_exist_institute}}</span>
                        </router-link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </draggable>
          <button type="button" class="list-group-item list-group-item-action">
            <div class="row d-flex">
              <div class="col">
                <div class="row">
                  <div class="col d-flex" v-if="settings.authors.max_authors > authors.length">
                    <router-link :to="'authors/author/add'">
                      <button class="btn btn-success">
                        <icon :icon="['fad', 'user-plus']"/>
                        {{wording[abstract.setting_submission_id].buttons.add_author}}
                      </button>
                    </router-link>
                  </div>
                  <div class="col d-flex" v-else>
                    <div class="alert alert-warning">
                      <icon :icon="['fad', 'exclamation']"/>&nbsp;{{wording[abstract.setting_submission_id].author.max_author_reached}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </button>
        </div>
      </div>
    </div>
    <Studygroup class="mt-3" v-if="settings.authors.studygroup"></Studygroup>
    <div class="row mt-3" v-if="authors.length > 0">
      <div class="col">
        <h5 class="font-weight-bold">{{wording[0].buttons.preview}}:</h5>
        <AuthorPreview class="text-muted"/>
      </div>
    </div>
    <div class="row mt-4" v-if="mode.confirm != true">
      <div class="col d-flex">
        <router-link
          :to="previousSite(getCurrentPages(abstract.setting_submission_id), getCurrentPageByType(abstract.setting_submission_id, 2).id)"
          class="mr-auto">
          <button type="button" class="btn btn-info">
            <icon :icon="['fas', 'angle-left']" size="lg"/>
            {{wording[0].buttons.back}}
          </button>
        </router-link>
        <router-link
          :to="nextSite(getCurrentPages(abstract.setting_submission_id), getCurrentPageByType(abstract.setting_submission_id, 2).id)"
          class="ml-auto"
          v-if="hasNextSite(getCurrentPages(abstract.setting_submission_id), getCurrentPageByType(abstract.setting_submission_id, 2).id)">
          <button type="button" class="btn btn-info float-right">{{wording[0].buttons.next}}
            <icon :icon="['fas', 'angle-right']" size="lg"/>
          </button>
        </router-link>
      </div>
    </div>
    <!--Modal View für Hinweise beim Presenterchange-->
    <div class="modal fade" id="maxPresenterModal" tabindex="-1" role="dialog"
         aria-labelledby="maxPresenterModal" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger" id="maxPresenterModalTitle">
              {{wording[abstract.setting_submission_id].author.modal_max_title}}</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-1 d-flex">
                <icon :icon="['fad', 'exclamation']" class="my-auto mx-auto text-warning fa-2x"/>
              </div>
              <div class="col">
                <Speaker :submission_id="abstract.setting_submission_id" area="author" textkey="modal_max_text"/>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">{{wording[0].buttons.next}}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="needPresenterModal" tabindex="-1" role="dialog"
         aria-labelledby="needPresenterModal" aria-hidden="true" data-keyboard="false" data-backdrop="static">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger" id="needPresenterModalTitle">
              {{wording[abstract.setting_submission_id].author.modal_needpresenter_title}}</h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-1 d-flex">
                <icon :icon="['fad', 'exclamation']" class="my-auto mx-auto text-warning fa-2x"/>
              </div>
              <div class="col">
                <Speaker :submission_id="abstract.setting_submission_id" area="author"
                         textkey="modal_needpresenter_text"/>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <router-link :to="'authors/author/'+ needEditAuthorID +'/edit'">
              <button type="button" class="btn btn-primary" data-dismiss="modal">{{wording[0].buttons.edit}}</button>
            </router-link>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="deletePresenterModal" tabindex="-1" role="dialog"
         aria-labelledby="deletePresenterModal" aria-hidden="true" data-keyboard="false" data-backdrop="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger" id="deletePresenterModalTitle">
              {{wording[abstract.setting_submission_id].author.modal_deletepresenter_title}}</h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-1 d-flex">
                <icon :icon="['fad', 'exclamation']" class="my-auto mx-auto text-warning fa-2x"/>
              </div>
              <div class="col">
                <Speaker :submission_id="abstract.setting_submission_id" area="author"
                         textkey="modal_deletepresenter_text"/>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex">
            <button type="button" class="btn btn-danger mr-auto" data-dismiss="modal">
              <icon :icon="['fad', 'ban']"/>
              Cancel
            </button>
            <button type="button" class="btn btn-success ml-auto" data-dismiss="modal"
                    v-on:click="deleteAuthor(deleteAuthorObj)">
              <icon :icon="['fad', 'check']"/>
              Yes
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="deleteAuthorModal" tabindex="-1" role="dialog"
         aria-labelledby="deleteAuthorModal" aria-hidden="true" data-keyboard="false" data-backdrop="dialog">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title text-danger" id="deleteAuthorModalTitle">
              {{wording[abstract.setting_submission_id].author.modal_deleteauthor_title}}</h5>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-1 d-flex">
                <icon :icon="['fad', 'exclamation']" class="my-auto mx-auto text-warning fa-2x"/>
              </div>
              <div class="col">
                <Speaker :submission_id="abstract.setting_submission_id" area="author"
                         textkey="modal_deleteauthor_text"/>
              </div>
            </div>
          </div>
          <div class="modal-footer d-flex">
            <button type="button" class="btn btn-danger mr-auto" data-dismiss="modal">
              <icon :icon="['fad', 'ban']"/>
              {{wording[0].buttons.cancel}}
            </button>
            <button type="button" class="btn btn-success ml-auto" data-dismiss="modal"
                    v-on:click="deleteAuthor(deleteAuthorObj)">
              <icon :icon="['fad', 'check']"/>
              {{wording[0].buttons.delete}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapState, mapActions, mapMutations, mapGetters} from 'vuex'
  import draggable from 'vuedraggable'
  import AuthorPreview from './AuthorPreview'
  import Speaker from "../helpers/Speaker";
  import InstituteList from "./InstituteList";
  import Studygroup from "./Studygroup";

  export default {
    components: {
      Speaker,
      draggable,
      AuthorPreview,
      InstituteList,
      Studygroup
    },
    data() {
      return {
        needEditAuthorID: 0,
        deleteAuthorObj: {},
        showInstitutes: false
      };
    },
    methods: {
      ...mapActions([
        'PUT_AUTHOR_ROLE', 'VALIDATE_TARGET', 'PUT_AUTHOR'
      ]),
      instituteString(institutes) {
        let institute = institutes.find(institute => institute.order === 1);
        let name = institute.name;
        if (institute.country_code) {
          name += ', ' + this.wording[0].country[institute.country_code];
        }
        return name
      },
      hasError(author_id) {
        let validation = this.authorvalidation.errors.find(valid => valid.author_id === author_id);
        if (!validation) {
          return false;
        } else {
          return true;
        }
      },
      deleteAuthorShowModal(author) {
        this.deleteAuthorObj = author;
        if (author.role_id === 2) {
          $('#deletePresenterModal').modal('show');
        } else {
          $('#deleteAuthorModal').modal('show');
        }
      },
      deleteAuthor(author) {
        if (author.role_id === 1 || this.authors.length === 1) {
          this.$store.dispatch('DELETE_AUTHOR', author);
          return true;
        }
        if (this.authors[0].id !== author.id) {
          this.changeToPresenter(this.authors[0]);
        } else {
          this.changeToPresenter(this.authors[1]);
        }
        this.$store.dispatch('DELETE_AUTHOR', author)
      },
      implodeAuthor(author) {
        let additionalKey = 'additional_content';
        let author_implode = {};
        Object.assign(author_implode, author);
        if (Object.keys(author_implode).includes(additionalKey)) {
          let additionals = author_implode[additionalKey];
          delete author_implode[additionalKey];
          for (let itemkey in additionals) {
            author_implode[additionalKey + '__' + itemkey] = additionals[itemkey];
          }
        }
        return author_implode;
      }, changeToPresenter(author) {
        if (this.settings.authors.max_presenter > this.getPresenter.length) {
          author.role_id = 2;
          this.putPresenter(author.id, 2);
          let target = this.abstract.setting_submission_id + '/presenter/author';
          let data = {template: {}, target: target};
          data.template = this.implodeAuthor(author);
          this.VALIDATE_TARGET(data).then((result) => {
            this.error = {};
          }).catch((error) => {
            this.error = error.response.data;
            this.needEditAuthorID = author.id;
            $('#needPresenterModal').modal('show');
          })
        } else if (this.settings.authors.max_presenter === 1) {
          // Wenn er nur einen hat, switchen wir.
          let presenter = this.getPresenter;
          presenter[0].role_id = 1;
          this.putPresenter(presenter[0].id, 1);
          this.putPresenter(author.id, 2);
          author.role_id = 2;
          let target = this.abstract.setting_submission_id + '/presenter/author';
          let data = {template: {}, target: target};
          data.template = this.implodeAuthor(author);
          this.VALIDATE_TARGET(data).then((result) => {
            this.error = {};
          }).catch((error) => {
            this.error = error.response.data;
            this.needEditAuthorID = author.id;
            $('#needPresenterModal').modal('show');
          })
        } else {
          //Hat er mehr als einen, muss er ran.
          $('#maxPresenterModal').modal('show');
        }
      },
      putPresenter(author_id, role_id) {
        this.PUT_AUTHOR({template: {role_id: role_id}, id: author_id}).then((result) => {
          this.processing.author = false;
          this.$noty.success(this.wording[0].notify.save_success);
        }).catch((error) => {
          this.$noty.error(this.wording[0].notify.save_not_success);
          this.processing.author = false;
        })
      },
      validate(author) {
        let target = this.abstract.setting_submission_id + '/presenter/author';
        let data = {template: {}, target: target};
        data.template = this.implodeAuthor(author);
        this.VALIDATE_TARGET(data).then((result) => {
          this.error = {};
          return true;
        }).catch((error) => {
          this.error = error.response.data;
          return false;
        })
      }
    },
    created() {
      this.$store.dispatch('GET_AUTHORS', this.$route.params.id)
    },
    computed: {
      ...mapState([
        'wording', 'abstract', 'settings', 'processing', 'authorvalidation', "mode"
      ]),
      ...mapGetters([
        'getCurrentPages', 'getCurrentPageById', 'getCurrentPageByType', 'getPresenter'
      ]),
      authors: {
        get() {
          return this.$store.state.authors
        },
        set(listing) {
          listing.forEach((element, index) => {
            element.order = index + 1;
            this.PUT_AUTHOR({template: {order: element.order}, id: element.id}).then((result) => {
              this.processing.author = false;
              this.$noty.success(this.wording[0].notify.save_success);
            }).catch((error) => {
              this.$noty.error(this.wording[0].notify.save_not_success);
              this.processing.author = false;
            })
          });
          this.$store.commit('SET_AUTHORS', {authors: listing});
        }
      }
    },
  }
</script>

<style>
  .handle {
    cursor: move;
    cursor: -webkit-grabbing;
  }
</style>
